import React from "react"
import clsx from "clsx"

export default class CustomerPortalSettingsPresenterGeneral extends React.Component {
	constructor(props) {
		super(props)
	}

	render() {
		var tabClasses = clsx({
			'active': this.props.active_tab == 'general',
			'tab-pane': true,
      'container': true,
		})

		return (
			<div className={tabClasses} id="general">
				<div className="row active tab-pane">
					<div className="col-md-4">
						<div className="form-group">
							<label style={{ marginRight: "4px" }}>  {I18n.t("check_in")} </label>
							<span className="ss-help help" title={I18n.t("customer_portal_settings_check_in_helper_text")}></span>
							<br />
							{I18n.t(this.props.customer_portal_setting.check_in)}
						</div>
					</div>
					<div className="col-md-4">
						<div className="form-group">
							<label style={{ marginRight: "4px" }}>  {I18n.t("check_out")} </label>
							<span className="ss-help help" title={I18n.t("customer_portal_settings_check_out_helper_text")}></span>
							<br />
							{I18n.t(this.props.customer_portal_setting.check_out)}
						</div>
					</div>
					<div className="col-md-4">
						<div className="form-group">
							<label style={{ marginRight: "4px" }}>  {I18n.t("cancel_reservation")} </label>
							<span className="ss-help help" title={I18n.t("customer_portal_settings_cancel_reservation_helper_text")}></span>
							<br />
							{I18n.t(this.props.customer_portal_setting.cancel_reservation)}
						</div>
					</div>
				</div>
				<div className="row active tab-pane">
					<div className="col-sm-4">
						<div className="form-group">
							<label style={{ marginRight: "4px" }}>  {I18n.t("send_invitation")} </label>
							<span className="ss-help help" title={I18n.t("customer_portal_settings_send_invitation_helper_text")}></span>
							<br />
							{I18n.t(this.props.customer_portal_setting.send_invitation)}
						</div>
					</div>
				</div>
			</div>
		);
	}
}
